import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setPostAuthorizationRoot = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_AUTHORIZATION_ROOT
            });

            if (data.status === 'success') {
                localStorage.setItem('rootToken', data.token);
                dispatch(Action.SetAuthorizeAction(true))
                window.location.replace(window.location.origin);
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostAuthorizationRoot as SetPostAuthorizationRoot
}